if(!customElements.get('custom-header')){
    class CustomHeader extends HTMLElement {
        constructor(){
          super();
    
          this.init();
        }
    
        init(){
            this.setHeaderHeightProperty();

            if(!this.headerHeightEventsBound){
                window.addEventListener('load', () => {
                    this.setHeaderHeightProperty();
                });

                window.addEventListener('resize', () => {
                    this.setHeaderHeightProperty();
                });

                this.headerHeightEventsBound = true;
            }
    
            this.dropdowns = this.querySelectorAll('[data-dropdown]');
        
            this.searchBtn = this.querySelector('.nav-item--search');
            this.searchBar = document.querySelector('predictive-search');
            this.cartDrawer = document.querySelector('cart-drawer');

            if(this.searchBar){
                this.searchBtn.setAttribute('aria-hidden', 'false');
                this.searchBtn.addEventListener('click', (e) => {
                    e.preventDefault();
                    this.openSearchBar();
                });
                
                this.searchBar.addEventListener('click', (e) => {
                    if(e.target == this.searchBar){
                        this.closeSearchBar();
                    }
                });  
            }else{
                this.searchBtn.setAttribute('aria-hidden', 'true');
            }

            if(this.cartDrawer){
                this.querySelectorAll('.nav-item--cart a').forEach(item => {
                    item.addEventListener('click', (e) => {
                        e.preventDefault();
                        this.cartDrawer.open();
                    });
                });
            }

            this.menuType = this.dataset.menuType;

            // Menu type - dropdown
            this.dropdownMenus = this.querySelectorAll('.nav-item--dropdown[data-menu-type="dropdown"], .localization-select-wrapper');
            if(this.dropdownMenus){
                this.dropdownMenus.forEach((item) => {
                    item.addEventListener('mouseover', (e) => {
                        this.openDropdown(e);
                    });
                    item.addEventListener('mouseout', (e) => {
                        this.closeDropdown(e);
                    });

                    item.addEventListener('keydown', (e) => {
                        if(e.code === 'Enter'){
                            const currentTarget = e.target;
                            if(currentTarget.closest('.nav-dropdown__item') && currentTarget.closest('.nav-dropdown__item').querySelectorAll('.nav-dropdown').length === 0){
                                return;
                            }
                        }

                        if(e.code === 'Space' || e.code === 'Enter'){
                            e.preventDefault();
                            this.openDropdown(e);
                        }
                    });
                    item.addEventListener('focusin', (e) => {
                        this.keyboardFocusDropdown = e.target.closest('.nav-dropdown');
                        this.keyboardFocusItem = e.currentTarget;
                    })
                    item.addEventListener('focusout', (e) => {
                        if(!this.keyboardFocusDropdown) return;
                        if(this.keyboardFocusDropdown.closest('.nav-item') != e.target.closest('.nav-item')){
                            this.closeDropdown(e);
                        }else if((this.keyboardFocusDropdown.closest('.nav-item') == e.target.closest('.nav-item')) && (this.keyboardFocusDropdown == e.target.closest('.nav-dropdown'))){
                            if(e.target.closest('.nav-dropdown') != this.keyboardFocusDropdown.closest('.nav-dropdown')){
                                this.closeDropdown(e);
                            }
                        }else if(e.relatedTarget.closest('.nav-item') !== e.currentTarget.closest('.nav-item')){
                            this.closeDropdown(e);
                        }
                    });

                    this.adjustDropdownHeight(item);
                });
            }

            // Menu type - mega menu
            this.megaMenu = this.querySelectorAll('.nav-item--dropdown[data-menu-type="mega-menu"], .nav-item--dropdown[data-menu-type="mega-menu-detailed"]');
            if(this.megaMenu){
                this.megaMenu.forEach((item) => {
                    item.addEventListener('mouseover', (e) => {
                        // Cancels any pending close from a moment ago, including one
                        // started by a different mega menu item we've since re-entered
                        // (e.g. moving diagonally from the trigger down into the panel).
                        clearTimeout(this.megaMenuCloseTimer);
                        this.itemOnHover = e.currentTarget;
                        this.openMegaMenu();
                    });
                    item.addEventListener('mouseout', (e) => {
                        // e.currentTarget is the trigger <li>, which also contains its
                        // mega menu panel — so relatedTarget being inside it covers any
                        // path between the trigger and the panel, diagonal moves included,
                        // without needing to know their exact on-screen geometry.
                        if(e.relatedTarget && e.currentTarget.contains(e.relatedTarget)) return;

                        clearTimeout(this.megaMenuCloseTimer);
                        this.megaMenuCloseTimer = setTimeout(() => {
                            this.closeMegaMenu();
                        }, 300);
                    });
                    item.addEventListener('keydown', (e) => {
                        if(e.code === 'Space' || e.code === 'Enter'){
                            e.preventDefault();
                            this.itemOnHover = e.currentTarget;
                            this.openMegaMenu();
                        }
                    })
                    item.addEventListener('focusin', (e) => {
                        this.keyboardFocusMegaMenu = e.target.closest('.nav-mega-menu');
                        this.keyboardFocusItem = e.currentTarget;
                    });
                    item.addEventListener('focusout', (e) => {
                        if(!this.keyboardFocusMegaMenu) return;
                        if(this.keyboardFocusMegaMenu.closest('.nav-item') != e.target.closest('.nav-item')){
                            this.closeMegaMenu();
                        }else if(e.relatedTarget.closest('.nav-item') !== e.currentTarget.closest('.nav-item')){
                            this.closeMegaMenu();
                        }
                    });
                });
            }

            // Menu type - mega menu (detailed, cascading columns)
            this.detailedMegaMenuItems = this.querySelectorAll('.nav-mega-menu--detailed .mmd-item--parent');
            if(this.detailedMegaMenuItems){
                this.detailedMegaMenuItems.forEach((item) => {
                    item.addEventListener('mouseenter', (e) => {
                        this.activateDetailedMegaMenuItem(e.currentTarget);
                    });
                    item.querySelector(':scope > a').addEventListener('focus', (e) => {
                        this.activateDetailedMegaMenuItem(e.currentTarget.closest('.mmd-item'));
                    });
                });
            }

            this.normalMenus = this.querySelectorAll('.nav-item:not(.nav-item--dropdown[data-menu-type])');
            this.normalMenus.forEach((item) => {
                item.addEventListener('focusin', () => {
                    if(this.keyboardFocusItem){
                        this.keyboardFocusItem.querySelectorAll('.nav-dropdown-wrapper').forEach((item) => {
                            item.setAttribute('data-hidden', 'true');
                        })
                    }
                })
            });

            // Hamburger mobile menu
            this.hamburgerMobileBtn = this.querySelector('.header__mobile-hamburger');
            if(this.hamburgerMobileBtn)
                this.hamburgerMobileBtn.addEventListener('click', () => { this.openHamburgerMobileMenu() });
        
            this.hamburgerMobileMenu = this.querySelector('.nav-mobile-menu--hamburger');
            this.hamburgerMobileMenuSearchBtn = this.hamburgerMobileMenu.querySelector('.btn-search');
            if(this.searchBar){
                this.hamburgerMobileMenuSearchBtn.setAttribute('aria-hidden', 'false');

                this.hamburgerMobileMenuSearchBtn.addEventListener('click', () => {
                    this.openSearchBar();
                });    
            }else{
                this.hamburgerMobileMenuSearchBtn.setAttribute('aria-hidden', 'true');
            }
         
            if(this.menuType == 'mega-menu'){
                // Hamburger menu
                this.hamburgerMegaBtn = this.querySelector('.header__mega-hamburger-wrapper');
                
                if(this.hamburgerMegaBtn){
                    this.hamburgerMegaBtn.addEventListener('click', (event) => { 
                        event.preventDefault();
                        this.openHamburgerMegaMenu() 
                    });
                    
                    this.hamburgerMegaBtn.addEventListener('keydown', (event) => {
                        if(event.keyCode === 13){
                            event.preventDefault();
                            this.openHamburgerMegaMenu();
                        }
                    })
                }
            }
        
            if(this.getAttribute('data-sticky') == 'true'){
        
                // Sticky header
                this.enableStickyHeader();
                window.addEventListener('scroll', () => {
                    this.enableStickyHeader();
                })
        
            }

            if(this.querySelector('.header__row--menu--dummy')){
                var leftMinWidth = this.querySelector('.header__nav-localization')? this.querySelector('.header__nav-localization').clientWidth : 0;
                leftMinWidth = this.querySelector('.header__nav-account')? leftMinWidth + this.querySelector('.header__nav-account').clientWidth : leftMinWidth;

                this.querySelector('.header__row--menu--dummy').style.minWidth = `${leftMinWidth}px`;
            }

            this.setHeaderHeightProperty();
        }

        refresh(){
            this.init();
        }
    
        enableStickyHeader(){
            var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        
            if(document.querySelector('custom-announcement-bar')){
                scrollTop -= document.querySelector('custom-announcement-bar').offsetHeight
            }
            if(scrollTop > 1){
                this.setAttribute('data-scroll', 'true');
            }else{
                this.setAttribute('data-scroll', 'false');
            }
        }

        setHeaderHeightProperty(){
            var headerHeight = this.offsetHeight;
            var announcementBar = document.querySelector('custom-announcement-bar');

            if(announcementBar){
                headerHeight += announcementBar.offsetHeight;
            }

            document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
        }

        adjustDropdownHeight(item){
            if(!item.querySelector('.nav-dropdown')) return;

            var navDropdowns = item.querySelectorAll('.nav-dropdown');

            var clone = navDropdowns[0].closest('.nav-dropdown-wrapper').cloneNode(true);

            item.appendChild(clone);
            var contentHeight = clone.offsetHeight;

            clone.style.visibility = 'hidden';
            item.removeChild(clone);
            
            navDropdowns[0].closest('.nav-dropdown-wrapper').style.setProperty('--content-height-1', (contentHeight - 3)+ 'px');

            if(navDropdowns.length > 0){
                navDropdowns.forEach((navDropdown, idx) => {
                    if(idx != 0){
                        var navDropdownClone = navDropdown.closest('.nav-dropdown-wrapper').cloneNode(true);

                        navDropdownClone.style.maxHeight = 'unset';
                        navDropdownClone.style.visibility = 'hidden';
    
                        navDropdown.appendChild(navDropdownClone);
                        var contentHeight = navDropdownClone.scrollHeight;
                        navDropdown.removeChild(navDropdownClone);
    
                        navDropdown.closest('.nav-dropdown-wrapper').style.setProperty('--content-height-2', (contentHeight - 2) + 'px');
                    }
                })
            }
        }
    
        openSearchBar(){
            this.searchBar.openSidebar();
            this.closeHeaderDropdowns();
        }
    
        closeSearchBar(){
            this.searchBar.closeSidebar();
        }
    
        openDropdown(e){
            // Set dropdown menu position
            this.querySelectorAll('.nav-dropdown__item .nav-dropdown-wrapper').forEach(item => {
                let dropdownOffset = item.closest('.nav-dropdown__item').offsetHeight;
                item.style.top = `${dropdownOffset}px`;
            });

            this.closeHeaderDropdowns();
        
            if(e.currentTarget.querySelector('.nav-dropdown-wrapper')){
                e.currentTarget.querySelectorAll('.nav-dropdown-wrapper')[0].setAttribute('data-hidden', 'false');
            }

            if(e.currentTarget.getAttribute('data-menu-type') == 'dropdown'){
                var childElem = e.target;
                childElem = childElem.classList.contains('nav-dropdown__item:not(.nav-dropdown__item--last)')? e.target : e.target.closest('.nav-dropdown__item:not(.nav-dropdown__item--last)');
                var childNavDropdowns = childElem.querySelector('.nav-dropdown-wrapper');
                if(childElem !== e.currentTarget && childNavDropdowns){
                    childElem.querySelector('.nav-dropdown-wrapper').setAttribute('data-hidden', 'false');
                }
            }
        }
    
        closeDropdown(e){
            e.currentTarget.querySelectorAll('.nav-dropdown-wrapper').forEach((item) => {
                item.setAttribute('data-hidden', 'true');
            })
        }
    
        openHamburgerMobileMenu(){
            if(this.hamburgerMobileMenu.getAttribute('data-hidden') == 'false'){
                this.closeHamburgerMobileMenu();
                return;
            }
            
            this.hamburgerMobileMenu.querySelectorAll('.btn-close').forEach((item) => {
                item.addEventListener('click', () => { this.closeHamburgerMobileMenu(); })
            })
        
            this.closeHeaderDropdowns();
        
            this.hamburgerMobileBtn.setAttribute('data-active', 'true');
            this.hamburgerMobileMenu.setAttribute('data-hidden', 'false');
        
            document.querySelector('html').style.overflow = 'hidden';
        }
    
        closeHamburgerMobileMenu(){
            this.hamburgerMobileBtn.setAttribute('data-active', 'false');
            this.hamburgerMobileMenu.setAttribute('data-hidden', 'true');
        
            document.querySelector('html').style.overflow = 'initial';
        }
    
        openHamburgerMegaMenu(){
            if(this.hamburgerMegaMenu == undefined) this.hamburgerMegaMenu = this.querySelector('.nav-mega-menu--hamgurger');
        
            if(this.hamburgerMegaMenu.getAttribute('data-hidden') == 'false'){
                this.closeHamburgerMegaMenu();
                return;
            }
        
            this.closeHeaderDropdowns();
        
            this.hamburgerMegaBtn.querySelector('.header__mega-hamburger').setAttribute('data-active', 'true');
            this.hamburgerMegaMenu.setAttribute('data-hidden', 'false');

            document.addEventListener('click', this.closeHamburgerMegaMenuByClickDocument.bind(this));

            this.setAttribute('data-open-megamenu', 'true');
        }

        closeHamburgerMegaMenuByClickDocument(e){
            if(e.target.nodeName === 'CUSTOM-HEADER' || e.target.closest('custom-header')) return;
            else{
                this.closeHamburgerMegaMenu();
            }
        }
    
        closeHamburgerMegaMenu(){
            this.hamburgerMegaBtn.querySelector('.header__mega-hamburger').setAttribute('data-active', 'false');
            this.hamburgerMegaMenu.setAttribute('data-hidden', 'true');
 
            document.removeEventListener('click', this.closeHamburgerMegaMenuByClickDocument.bind(this));

            this.setAttribute('data-open-megamenu', 'false');
        }
    
        openMegaMenu(){
            clearTimeout(this.megaMenuCloseTimer);
            this.closeHeaderDropdowns();

            if(this.itemOnHover.querySelector('.nav-mega-menu')){
                this.itemOnHover.querySelector('.nav-mega-menu').setAttribute('data-hidden', 'false');
            }

            this.setAttribute('data-open-megamenu', 'true');
        }
    
        closeMegaMenu(){
            if(this.itemOnHover == null) return;
            this.itemOnHover.querySelectorAll('.nav-mega-menu').forEach((item) => {
                item.setAttribute('data-hidden', 'true');
            })
            this.itemOnHover = null;

            this.setAttribute('data-open-megamenu', 'false');
        }
    
        activateDetailedMegaMenuItem(li){
            if(!li) return;

            var index = li.dataset.mmdIndex;
            var col = li.closest('.mmd-col');
            var row = li.closest('.mmd-row');
            if(!col || !row) return;

            col.querySelectorAll(':scope > .mmd-item.is-active').forEach((item) => {
                item.classList.remove('is-active');
            });
            li.classList.add('is-active');

            var panels = row.querySelector(':scope > .mmd-panels');
            if(!panels) return;

            panels.querySelectorAll(':scope > .mmd-panel.is-active').forEach((panel) => {
                panel.classList.remove('is-active');
            });

            var panel = panels.querySelector(':scope > .mmd-panel[data-mmd-panel-index="' + index + '"]');
            if(panel) panel.classList.add('is-active');
        }

        closeHeaderDropdowns(){
            clearTimeout(this.megaMenuCloseTimer);
            if(this.hamburgerMegaBtn) {
                this.hamburgerMegaBtn.setAttribute('data-active', 'false');
                this.hamburgerMegaBtn.querySelector('.header__mega-hamburger').setAttribute('data-active', 'false');
            }
            this.hamburgerMobileBtn.setAttribute('data-active', 'false');
            this.dropdowns.forEach((item) => {
                item.setAttribute('data-hidden', 'true');
            })
        }
    }

    customElements.define('custom-header', CustomHeader);
}
